function reactPlugin() { }

function formatComponentName(vm) {
    if (vm.$root === vm) {
        return 'root instance';
    }
    var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
    return ((name ? 'component <' + name + '>' : 'anonymous component') +
        (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : ''));
}
function vuePlugin(errorDetector, Vue) {
    if (!Vue || !Vue.config)
        return;
    var _oldOnError = Vue.config.errorHandler;
    Vue.config.errorHandler = function VueErrorHandler(error, vm, info) {
        if (console.error) {
            console.error({ error: error, vm: vm, info: info });
        }
        else if (console.log) {
            console.log('Vue.config.errorHandler', { error: error, vm: vm, info: info });
        }
        var metaData = {};
        var message = error.message;
        var url = document.location.href;
        var line = error.stack;
        if (Object.prototype.toString.call(vm) === '[object Object]') {
            metaData.componentName = formatComponentName(vm);
            metaData.propsData = vm.$options.propsData;
        }
        if (typeof info !== 'undefined') {
            metaData.lifecycleHook = info;
        }
        if (vm && vm.$store && vm.$store.state) {
            metaData.vm = vm.$store.state;
        }
        else {
            metaData.vm = '';
        }
        errorDetector = errorDetector || window.ErrorDetector;
        if (errorDetector && errorDetector.onerror) {
            errorDetector.onerror(message, url, line, '', error, metaData);
        }
        else {
            // 缓存到loader
            var detectorLoader = window.detectorLoader;
            detectorLoader &&
                detectorLoader.queue.error.push(message + "\n" + url + "\uFF1A" + line + "\uFF1A" + JSON.stringify(metaData));
        }
        if (typeof _oldOnError === 'function') {
            _oldOnError.call(this, error, vm, info);
        }
        return true;
    };
}

export { reactPlugin, vuePlugin };
//# sourceMappingURL=detector-plugins.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@broker/detector-plugins/dist/detector-plugins.es5.js
// module id = wjXh
// module chunks = 0